function TodosError(){
    return(
        <p>Se ha presentado un error</p>
    )
}
export {TodosError}